import { all } from "redux-saga/effects";
import { adUnitBuilderAssetFormSaga } from "./createAssetForms";
import { buildAdUnit } from "./buildAdUnit";
import { loadAdUnitList } from "./loadAdUnitList";
import { uploadFileForAsset } from "./uploadFileForAsset";
import { cleanAssetForms } from "./cleanAssetForms";
import { emptyExistingAdUnitSaga } from "./emptyExistingAdUnit";

export function* adUnitBuilderSaga() {
    yield all([
        adUnitBuilderAssetFormSaga(),
        buildAdUnit(),
        loadAdUnitList(),
        uploadFileForAsset(),
        cleanAssetForms(),
        emptyExistingAdUnitSaga()
    ]);
}
